import { render } from "./MainSenzaHeader.vue?vue&type=template&id=fb2cbbee&scoped=true"
import script from "./MainSenzaHeader.vue?vue&type=script&lang=js"
export * from "./MainSenzaHeader.vue?vue&type=script&lang=js"

import "./MainSenzaHeader.vue?vue&type=style&index=0&id=fb2cbbee&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/byte-dev.it/carma.byte-dev.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb2cbbee"]])

export default __exports__